/**
 * useBrowserDetection Hook
 * Detects browser type, version, OS, and PWA status
 */

import { useState, useEffect } from 'react'
import {
  detectBrowser,
  detectOS,
  detectDeviceType,
  getBrowserEnvironment,
  isPWA,
} from 'src/services/mediaPermissions'

export const useBrowserDetection = () => {
  const [browserInfo, setBrowserInfo] = useState({
    browser: null,
    os: null,
    deviceType: null,
    isPWA: false,
    isSecure: false,
    userAgent: '',
    isLoading: true,
  })

  useEffect(() => {
    const detectEnvironment = () => {
      try {
        const environment = getBrowserEnvironment()
        setBrowserInfo({
          ...environment,
          isLoading: false,
        })
      } catch (error) {
        console.error('Error detecting browser environment:', error)
        setBrowserInfo((prev) => ({
          ...prev,
          isLoading: false,
        }))
      }
    }

    detectEnvironment()
  }, [])

  return browserInfo
}

export default useBrowserDetection


















